import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_pages/solar")({
	component: () => null,
	beforeLoad: () => {
		throw redirect({
			to: "/data/solar",
			replace: true,
		});
	},
});
